import axiosInstance from "../Interceptors/axiosInstance.jsx";
import Cookies from "js-cookie";

const headers = {
  accept: "*/*",
  Authorization: `Bearer ${Cookies.get("accessToken")}`,
  "Content-Type": "application/json",
};

export const getAnnouncementBar = async () => {
  const response = await axiosInstance.get("announcement-bar-settings/get", { headers });
  return response.data?.result ?? null;
};

export const upsertAnnouncementBar = async (payload) => {
  return await axiosInstance.post("announcement-bar-settings/upsert", payload, {
    headers,
  });
};
